(function() {
    "use strict";

    angular.module("eSign")
        .controller("InsuranceController", ['$scope', '$window', 'signTaskService', 'sessionService', 'appConfig',
            function($scope, $window, signTaskService, sessionService, appConfig) {

                $scope.insurance;

                $scope.cancel = function () {
                    signTaskService.setInsuranceStepComplete(false, "", "").then(function (response) {
                        $window.location.href = appConfig.signCompletedUrl;
                    });
                    
                };
                $scope.order = function () {
                    var insuranceCode = "PAYMENT_INSURANCE";
                    if ($scope.insurance.fullCoverage === false) insuranceCode = "PAYMENT_INSURANCE_REDUCED";
                    if ($scope.insurance.otherInsurance === true) insuranceCode = $scope.insurance.externalCode;
                    signTaskService.setInsuranceStepComplete(true, insuranceCode, "").then(function (response) {
                        $window.location.href = appConfig.signCompletedUrl;
                    });
                };

                $scope.order_v2 = function () {
                    var insuranceCode = $scope.insurance.externalCode;
                    var acceptInsurance = (typeof $scope.acceptInsurance === 'undefined') ? false : $scope.acceptInsurance;
                    signTaskService.setInsuranceStepComplete(acceptInsurance, insuranceCode, $scope.insuranceCompany).then(function (response) {
                        $window.location.href = appConfig.signCompletedUrl;
                    });
                };

                $scope.declineClick = function() {
                    $scope.acceptInsurance = false;
                }

                $scope.acceptClick = function () {
                    $scope.declineInsurance = false;
                    $scope.insuranceCompany = "";
                }

                var getInsuranceInfo = function () {
                    signTaskService.getInsuranceForSignTask().then(function (response) {
                        
                        $scope.insurance = response.data;
                        if (!response.data.hasInsurance && !response.data.mustEnterInsuranceCompany) $window.location.href = appConfig.signCompletedUrl;
                    });
                };

                getInsuranceInfo();
            }
        ]);
}());
